// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

// Display video
function displayYTVideo(){

    // Load YT API
    var tag = document.createElement('script');

    // Get Video ID
    let re = /(https?:\/\/)?(((m|www)\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;   

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    $(".youtube").each(function(i){
        let videoId = $(this).attr('data-url').match(re)[8]; 
        console.log(videoId);

        // Based on the YouTube ID, we can easily find the thumbnail image
        $(this).css('backgroundImage', 'url(http://i.ytimg.com/vi/' + videoId + '/sddefault.jpg)');

        // Overlay the Play icon to make it look like a video player
        var play = document.createElement("div");
        play.setAttribute("class","play");
        $(this).append(play);

        $(this).click(function() {

            var player = new YT.Player($(this).attr('id'), {
                height: '360',
                width: '640',
                videoId: videoId,
                playerVars: { 
                    'autoplay': 1, 
                    'controls': 0,
                    'modestbranding': 1,
                    'loop': 1,
                    'showinfo': 0,
                    'rel': 0
                },
                events: {
                  'onReady': function(event) {
                    event.target.playVideo();
                  }
                }
            });
        });
    });
};

displayYTVideo();

console.log("Made with ❤ by Linaïa.");